module.exports = __webpack_public_path__ + "static/img/header-bg-vip-new.ce98b25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/withdraw/header-bg-vip-new.png
// module id = bRmk
// module chunks = 215